import { ApolloProvider } from "@apollo/client";
import React from "react";

import { useApolloClientManage } from "hooks/useApolloClientManage";

export const AuthorizedApolloProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const apolloClient = useApolloClientManage();

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
